import {State} from '../types/state'

export const getComponentSettings = (state: State) => state.component.settings
